import { UtilsService } from "src/app/core/services/utils/utils.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ApiSelectorService {
  SERVER_CONFIG =
    environment.baseURL +
    environment.environmentURL +
    environment.SERVER_CONFIG.calidadUrl;

  constructor(private http: HttpClient, private utils: UtilsService) {
    this.utils.getFromStorage("API_SELECTED").then((data)=>{
      let version = data.replace(/\./g, "");
      this.SERVER_CONFIG = environment.baseURL + version + environment.baseTest + environment.SERVER_CONFIG.calidadUrl;
    }).catch(()=>{
      this.SERVER_CONFIG = environment.baseURL + environment.environmentURL + environment.SERVER_CONFIG.calidadUrl;
    });
  }

  /**
   * Metodo que cambia las rutas del environment segun el api seleccionada (solo disponible para Testing y Dev)
   * @param environmentSelected api seleccionada
   */
  changeEnvironment(environmentSelected: string | undefined): void {
    if (environmentSelected) {
      const newEnvironment = environmentSelected.replace(/\./g, "");
      if (environment.message === "testing") {
        this.SERVER_CONFIG =
          environment.baseURL +
          newEnvironment +
          environment.baseTest +
          environment.SERVER_CONFIG.calidadUrl;
      }
    } else {
      this.SERVER_CONFIG =
        environment.baseURL +
        environment.environmentURL +
        environment.SERVER_CONFIG.calidadUrl;
    }
  }

  getApiVersions() {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiVersions).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }
}
